import { SortAccessor } from '~components/Tables/DeviceTables/types';
import { DBGWithType } from '~modules/devices/components/DeviceHealthTable/types';

export type DBGSortAccessor = SortAccessor<DBGWithType>;

export const dbgSortAccessors: Record<string, DBGSortAccessor> = {
  id: (dbg) => dbg.id,
  mac_address: (dbg) => dbg.macAddress,
  device_type: (dbg) => dbg.type,
  description: (dbg) => dbg.description ?? null,
};
